import { Components, Theme } from '@mui/material';

export const accordionStyles: Components<Theme>['MuiAccordion'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 0,
      boxShadow: 'none',
      border: 'none',
      p: 0,
      '&::before': {
        background: 'transparent'
      },
      '&.MuiPaper-root': {
        background: theme.palette.customGrey.light,
        p: 0
      }
    })
  }
};

export const accordionSummaryStyles: Components<Theme>['MuiAccordionSummary'] =
  {
    styleOverrides: {
      root: ({ theme }) => ({
        py: '4px',
        px: '16px',
        color: theme.palette.primary.main,
        '& .MuiSvgIcon-root': {
          fontSize: '16px'
        },
        '& .MuiAccordionSummary-content': {
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        },
        '& .MuiAccordionSummary-expandIconWrapper': {
          color: theme.palette.primary.main
        }
      })
    }
  };

export const accordionDetailsStyles: Components<Theme>['MuiAccordionDetails'] =
  {
    styleOverrides: {
      root: {
        padding: '0px 16px 16px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }
    }
  };
